import * as fromDatatype from '../datatype-library/index';

export interface bl_hc_consultation_prescription_medicine_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  consultation_guid:fromDatatype.GuidDataFieldInterface;
  medicine_guid: fromDatatype.GuidDataFieldInterface;
  dosage:fromDatatype.IntegerDatatypeInterface;
  frequency: fromDatatype.VarcharDatatypeInterface;
  duration:fromDatatype.IntegerDatatypeInterface;
  start_date: fromDatatype.VarcharDatatypeInterface;
  end_date: fromDatatype.VarcharDatatypeInterface;
  instructions: fromDatatype.VarcharDatatypeInterface;
  note: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_hc_consultation_prescription_medicine_link_RowClass implements bl_hc_consultation_prescription_medicine_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  consultation_guid:fromDatatype.GuidDataFieldInterface;
  medicine_guid: fromDatatype.GuidDataFieldInterface;
  dosage:fromDatatype.IntegerDatatypeInterface;
  frequency: fromDatatype.VarcharDatatypeInterface;
  duration:fromDatatype.IntegerDatatypeInterface;
  start_date: fromDatatype.VarcharDatatypeInterface;
  end_date: fromDatatype.VarcharDatatypeInterface;
  instructions: fromDatatype.VarcharDatatypeInterface;
  note: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}